import { render } from "./AboutGeneralPage.vue?vue&type=template&id=6e3c138e"
import script from "./AboutGeneralPage.vue?vue&type=script&lang=js"
export * from "./AboutGeneralPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__